
(function(){
"use strict";

var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
var gsap = window.gsap;
var hasGSAP = typeof gsap !== 'undefined' && !!gsap;
var ST = window.ScrollTrigger;
var hasST = hasGSAP && typeof ST !== 'undefined' && !!ST;
var SplitText = window.SplitText;
var hasSplit = hasGSAP && typeof SplitText !== 'undefined' && !!SplitText;
if(hasGSAP){ try{ if(hasST) gsap.registerPlugin(ST); if(hasSplit) gsap.registerPlugin(SplitText); }catch(e){} }
var isDesktop = !window.matchMedia('(max-width:900px)').matches;

/* ---------------- Lenis (single instance) ---------------- */
var lenis = null;
if(!RM && typeof window.Lenis !== 'undefined'){
  try{
    lenis = new window.Lenis({ duration:1.1, smoothWheel:true, wheelMultiplier:1, touchMultiplier:1.6 });
    if(hasST){
      lenis.on('scroll', ST.update);
      gsap.ticker.add(function(t){ lenis.raf(t*1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      var rafLoop = function(t){ lenis.raf(t); requestAnimationFrame(rafLoop); };
      requestAnimationFrame(rafLoop);
    }
  }catch(e){ lenis = null; }
}
function scrollToId(id){
  var el = document.querySelector(id); if(!el) return;
  if(lenis){ lenis.scrollTo(el, { offset:-70, duration:1.2 }); }
  else { el.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }); }
}
document.querySelectorAll('a[href^="#"]').forEach(function(a){
  a.addEventListener('click', function(e){
    var href = a.getAttribute('href');
    if(href && href.length > 1){ e.preventDefault(); scrollToId(href); }
  });
});

/* ---------------- custom cursor ---------------- */
(function(){
  var dot = document.getElementById('cDot'), ring = document.getElementById('cRing');
  if(!dot || !ring || RM || !isDesktop) return;
  var rx = window.innerWidth/2, ry = window.innerHeight/2, dx = rx, dy = ry;
  window.addEventListener('mousemove', function(e){
    dx = e.clientX; dy = e.clientY;
    dot.style.transform = 'translate(' + dx + 'px,' + dy + 'px) translate(-50%,-50%)';
  }, {passive:true});
  (function loop(){
    rx += (dx-rx)*0.18; ry += (dy-ry)*0.18;
    ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
    requestAnimationFrame(loop);
  })();
  document.querySelectorAll('[data-hover],a,button').forEach(function(el){
    el.addEventListener('mouseenter', function(){ ring.classList.add('hot'); });
    el.addEventListener('mouseleave', function(){ ring.classList.remove('hot'); });
  });
})();

/* ---------------- nav state + scroll progress ---------------- */
(function(){
  var bar = document.getElementById('topbar');
  var prog = document.getElementById('progress');
  var rider = document.getElementById('progRider');
  var annH = 34, hidden = false;
  function upd(){
    var y = lenis ? lenis.scroll : (window.pageYOffset || document.documentElement.scrollTop);
    if(bar){
      if(y > 40){ if(!hidden){ bar.classList.add('tight'); bar.style.transform = 'translateY(-' + annH + 'px)'; hidden = true; } }
      else if(hidden){ bar.classList.remove('tight'); bar.style.transform = 'translateY(0)'; hidden = false; }
    }
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.min(1, Math.max(0, y/h)) : 0;
    if(prog) prog.style.transform = 'scaleX(' + p + ')';
    if(rider){ rider.style.opacity = p > 0.004 ? '1' : '0'; rider.style.transform = 'translate(' + (p*window.innerWidth) + 'px,-50%)'; }
  }
  if(lenis) lenis.on('scroll', upd); else window.addEventListener('scroll', upd, {passive:true});
  window.addEventListener('resize', upd);
  upd();
})();

/* ---------------- announcement rotator ---------------- */
(function(){
  var rot = document.getElementById('annRot'); if(!rot) return;
  var lines = rot.querySelectorAll('.ann-line');
  if(lines.length < 2 || RM) return;
  var i = 0;
  function swap(){
    var cur = lines[i], nxt = lines[(i+1) % lines.length];
    if(hasGSAP){
      gsap.to(cur, { yPercent:-100, opacity:0, duration:0.55, ease:'power3.inOut' });
      gsap.fromTo(nxt, { yPercent:100, opacity:0 }, { yPercent:0, opacity:1, duration:0.55, ease:'power3.out',
        onStart:function(){ nxt.classList.add('on'); },
        onComplete:function(){ cur.classList.remove('on'); gsap.set(cur, { yPercent:100 }); } });
    } else {
      cur.classList.remove('on'); nxt.classList.add('on');
    }
    i = (i+1) % lines.length;
  }
  setInterval(swap, 4200);
})();

/* ---------------- canvas helper: IO gate ---------------- */
function gateCanvas(obj, el){
  if(!obj || !el) return;
  if(RM){ obj.staticFrame(); return; }
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(en){ if(en.isIntersecting) obj.start(); else obj.stop(); });
    }, {threshold:0.02});
    io.observe(el);
  } else obj.start();
}

/* ==========================================================
   HERO SET PIECE: THE ARC CHAMBER
   Charge builds between two poles, discharges across the gap,
   HUD readouts are bound to the running simulation.
   Drawing happens in BUFFER pixel space (W = canvas.width).
========================================================== */
function arcChamber(canvas){
  if(!canvas) return null;
  var ctx = canvas.getContext('2d'); if(!ctx) return null;
  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0, running = false, raf = 0, last = 0;
  var parts = [], arcs = [], rings = [];
  var charge = 0.06, surge = 0, discharges = 0, hudT = 0;
  var hud = {
    charge: document.getElementById('hudCharge'),
    pot: document.getElementById('hudPot'),
    disc: document.getElementById('hudDisc'),
    arcs: document.getElementById('hudArcs'),
    nodes: document.getElementById('hudNodes')
  };

  function poles(){
    return { a:{ x:W*0.14, y:H*0.5 }, b:{ x:W*0.86, y:H*0.5 } };
  }
  function resize(){
    var r = canvas.getBoundingClientRect();
    canvas.width = Math.max(1, Math.round(r.width * DPR));
    canvas.height = Math.max(1, Math.round(r.height * DPR));
    W = canvas.width; H = canvas.height;
    build();
  }
  function build(){
    parts = [];
    var n = W < 900 ? 34 : 68;
    for(var i=0;i<n;i++){
      parts.push({
        x: Math.random()*W, y: Math.random()*H,
        vx: 0, vy: 0,
        r: (0.7 + Math.random()*1.7) * DPR,
        ph: Math.random()*6.2832,
        sp: 0.25 + Math.random()*0.5
      });
    }
    arcs = []; rings = [];
    if(hud.nodes) hud.nodes.textContent = String(n);
  }
  function makeArc(ax, ay, bx, by, power, life){
    var segs = 9 + ((Math.random()*7)|0), offs = [];
    for(var i=0;i<segs;i++) offs.push({ o:(Math.random()*2-1), ph:Math.random()*6.2832, sp:1.2+Math.random()*2.4 });
    return { ax:ax, ay:ay, bx:bx, by:by, segs:segs, offs:offs, life:0, dur:life, power:power };
  }
  function fire(){
    var p = poles();
    arcs.push(makeArc(p.a.x, p.a.y, p.b.x, p.b.y, 1, 0.55));
    var branches = 2 + ((Math.random()*3)|0);
    for(var i=0;i<branches;i++){
      var f = 0.22 + Math.random()*0.56;
      var sx = p.a.x + (p.b.x-p.a.x)*f, sy = p.a.y + (p.b.y-p.a.y)*f;
      var ex = sx + (Math.random()*2-1)*W*0.16, ey = sy + (Math.random()*2-1)*H*0.42;
      arcs.push(makeArc(sx, sy, ex, ey, 0.5, 0.34));
    }
    rings.push({ x:(p.a.x+p.b.x)/2, y:(p.a.y+p.b.y)/2, r:0, life:0, dur:0.9 });
    discharges++;
  }
  function leader(){
    var p = poles(), fromA = Math.random() < 0.5;
    var s = fromA ? p.a : p.b;
    var ex = s.x + (fromA ? 1 : -1) * W * (0.06 + Math.random()*0.14);
    var ey = s.y + (Math.random()*2-1) * H * 0.3;
    arcs.push(makeArc(s.x, s.y, ex, ey, 0.34, 0.26));
  }
  function drawArc(a, t){
    var env = Math.sin(Math.PI * Math.min(1, a.life/a.dur));
    if(env <= 0.02) return;
    var dx = a.bx-a.ax, dy = a.by-a.ay, len = Math.sqrt(dx*dx+dy*dy) || 1;
    var nx = -dy/len, ny = dx/len, amp = Math.min(H*0.16, len*0.16);
    ctx.beginPath(); ctx.moveTo(a.ax, a.ay);
    for(var s=1;s<a.segs;s++){
      var f = s/a.segs, oo = a.offs[s-1];
      var wob = oo.o * (1 - Math.abs(f-0.5)*1.5) * amp * Math.sin(t*oo.sp + oo.ph);
      ctx.lineTo(a.ax + dx*f + nx*wob, a.ay + dy*f + ny*wob);
    }
    ctx.lineTo(a.bx, a.by);
    var g = ctx.createLinearGradient(a.ax, a.ay, a.bx, a.by);
    g.addColorStop(0, 'rgba(154,92,255,' + (env*0.55*a.power) + ')');
    g.addColorStop(0.5, 'rgba(79,139,255,' + (env*0.92*a.power) + ')');
    g.addColorStop(1, 'rgba(154,92,255,' + (env*0.55*a.power) + ')');
    ctx.strokeStyle = g; ctx.lineWidth = (1.4 + 1.6*a.power) * DPR; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.shadowColor = 'rgba(79,139,255,' + (env*0.9) + ')'; ctx.shadowBlur = 16 * DPR;
    ctx.stroke();
    ctx.shadowBlur = 0;
    ctx.strokeStyle = 'rgba(207,228,255,' + (env*0.6*a.power) + ')'; ctx.lineWidth = 0.7 * DPR;
    ctx.stroke();
  }
  function frame(now){
    if(!running) return;
    if(!last) last = now;
    var dt = Math.min(0.05, (now-last)/1000); last = now;
    var t = now/1000;
    var p = poles();

    charge += (0.155 + surge*0.75) * dt;
    surge *= Math.exp(-dt*1.5);
    if(charge >= 1){ charge = 0.07; fire(); }
    if(Math.random() < (0.5 + charge*2.2) * dt * 3) leader();

    ctx.clearRect(0,0,W,H);
    ctx.globalCompositeOperation = 'lighter';

    /* axis guide */
    ctx.beginPath(); ctx.moveTo(p.a.x, p.a.y); ctx.lineTo(p.b.x, p.b.y);
    ctx.strokeStyle = 'rgba(107,33,216,' + (0.1 + charge*0.16) + ')'; ctx.lineWidth = 1.2*DPR; ctx.stroke();

    /* particles drawn toward the axis, faster as charge rises */
    ctx.shadowColor = 'rgba(79,139,255,.85)'; ctx.shadowBlur = 7*DPR;
    var glow = 0.35 + charge*0.5;
    ctx.fillStyle = 'rgba(143,190,255,' + glow + ')';
    for(var i=0;i<parts.length;i++){
      var q = parts[i];
      var tx = p.a.x + (p.b.x-p.a.x) * ((Math.sin(t*q.sp + q.ph)*0.5)+0.5);
      var ty = p.a.y + Math.sin(t*0.7 + q.ph) * H * 0.06;
      var ddx = tx-q.x, ddy = ty-q.y;
      var pull = 0.0009 + charge*0.0032;
      q.vx += ddx*pull; q.vy += ddy*pull;
      q.vx *= 0.94; q.vy *= 0.94;
      q.x += q.vx; q.y += q.vy;
      ctx.beginPath(); ctx.arc(q.x, q.y, q.r, 0, 6.2832); ctx.fill();
    }
    ctx.shadowBlur = 0;

    /* arcs */
    var alive = 0;
    for(var k=arcs.length-1;k>=0;k--){
      var a = arcs[k]; a.life += dt;
      if(a.life >= a.dur){ arcs.splice(k,1); continue; }
      drawArc(a, t); alive++;
    }

    /* shock rings */
    for(var m=rings.length-1;m>=0;m--){
      var rg = rings[m]; rg.life += dt;
      if(rg.life >= rg.dur){ rings.splice(m,1); continue; }
      var rp = rg.life/rg.dur;
      ctx.beginPath();
      ctx.arc(rg.x, rg.y, rp * W * 0.42, 0, 6.2832);
      ctx.strokeStyle = 'rgba(154,92,255,' + ((1-rp)*0.35) + ')';
      ctx.lineWidth = (1 + (1-rp)*2.4) * DPR; ctx.stroke();
    }

    /* poles + charge halos */
    [p.a, p.b].forEach(function(pt){
      var halo = ctx.createRadialGradient(pt.x, pt.y, 0, pt.x, pt.y, (18 + charge*34) * DPR);
      halo.addColorStop(0, 'rgba(154,92,255,' + (0.32 + charge*0.42) + ')');
      halo.addColorStop(1, 'rgba(107,33,216,0)');
      ctx.fillStyle = halo;
      ctx.beginPath(); ctx.arc(pt.x, pt.y, (18 + charge*34)*DPR, 0, 6.2832); ctx.fill();
      ctx.fillStyle = 'rgba(107,33,216,.95)';
      ctx.beginPath(); ctx.arc(pt.x, pt.y, 9*DPR, 0, 6.2832); ctx.fill();
      ctx.fillStyle = 'rgba(207,228,255,' + (0.55 + charge*0.4) + ')';
      ctx.beginPath(); ctx.arc(pt.x, pt.y, 3.4*DPR, 0, 6.2832); ctx.fill();
      ctx.beginPath();
      ctx.arc(pt.x, pt.y, (14 + charge*20)*DPR, -1.5708, -1.5708 + charge*6.2832);
      ctx.strokeStyle = 'rgba(79,139,255,.8)'; ctx.lineWidth = 2*DPR; ctx.stroke();
    });

    ctx.globalCompositeOperation = 'source-over';
    ctx.shadowBlur = 0;

    /* HUD binding, throttled */
    hudT += dt;
    if(hudT > 0.08){
      hudT = 0;
      if(hud.charge) hud.charge.innerHTML = Math.round(charge*100) + '<small>%</small>';
      if(hud.pot) hud.pot.textContent = (2.4 + charge*9.8).toFixed(1) + ' kV';
      if(hud.disc) hud.disc.textContent = String(discharges);
      if(hud.arcs) hud.arcs.textContent = String(alive);
    }
    raf = requestAnimationFrame(frame);
  }
  function start(){ if(running) return; running = true; last = 0; raf = requestAnimationFrame(frame); }
  function stop(){ running = false; if(raf) cancelAnimationFrame(raf); }
  function staticFrame(){
    resize();
    var p = poles();
    ctx.clearRect(0,0,W,H);
    ctx.globalCompositeOperation = 'lighter';
    ctx.beginPath(); ctx.moveTo(p.a.x,p.a.y); ctx.lineTo(p.b.x,p.b.y);
    ctx.strokeStyle = 'rgba(107,33,216,.3)'; ctx.lineWidth = 1.4*DPR; ctx.stroke();
    for(var i=0;i<parts.length;i++){
      var q = parts[i];
      ctx.fillStyle = 'rgba(143,190,255,.5)';
      ctx.beginPath(); ctx.arc(q.x, q.y, q.r, 0, 6.2832); ctx.fill();
    }
    [p.a,p.b].forEach(function(pt){
      ctx.fillStyle = 'rgba(107,33,216,.95)';
      ctx.beginPath(); ctx.arc(pt.x, pt.y, 9*DPR, 0, 6.2832); ctx.fill();
      ctx.fillStyle = 'rgba(207,228,255,.75)';
      ctx.beginPath(); ctx.arc(pt.x, pt.y, 3.4*DPR, 0, 6.2832); ctx.fill();
    });
    ctx.globalCompositeOperation = 'source-over';
    if(hud.charge) hud.charge.innerHTML = '62<small>%</small>';
    if(hud.pot) hud.pot.textContent = '8.5 kV';
    if(hud.disc) hud.disc.textContent = '3';
    if(hud.arcs) hud.arcs.textContent = '2';
  }
  resize();
  var rzT = null;
  window.addEventListener('resize', function(){ if(rzT) clearTimeout(rzT); rzT = setTimeout(resize, 150); });
  return {
    start:start, stop:stop, staticFrame:staticFrame,
    surge:function(amount){ surge = Math.min(2.2, surge + (amount||0.9)); },
    blast:function(){ charge = 0.999; surge = Math.min(2.4, surge + 1.4); }
  };
}
var chamber = arcChamber(document.getElementById('chargeCanvas'));
gateCanvas(chamber, document.getElementById('heroStage'));
(function(){
  var stage = document.getElementById('stageCanvas');
  if(!stage || !chamber || RM) return;
  stage.addEventListener('click', function(){ chamber.surge(1.2); });
  stage.addEventListener('mousemove', function(){ chamber.surge(0.05); }, {passive:true});
})();

/* ---------------- final CTA spark field ---------------- */
function ctaSparks(canvas){
  if(!canvas) return null;
  var ctx = canvas.getContext('2d'); if(!ctx) return null;
  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0, parts = [], running = false, raf = 0, tt = 0;
  var target = { x:0, y:0, active:false };
  function resize(){
    var r = canvas.getBoundingClientRect();
    canvas.width = Math.max(1, Math.round(r.width*DPR));
    canvas.height = Math.max(1, Math.round(r.height*DPR));
    W = canvas.width; H = canvas.height;
    target.x = W/2; target.y = H/2;
    build();
  }
  function build(){
    parts = [];
    var n = W < 900 ? 30 : 52;
    for(var i=0;i<n;i++) parts.push({ x:Math.random()*W, y:Math.random()*H, vx:0, vy:0, r:(0.8+Math.random()*1.8)*DPR, ph:Math.random()*6.2832 });
  }
  function frame(now){
    if(!running) return;
    tt = now/1000;
    ctx.clearRect(0,0,W,H);
    ctx.globalCompositeOperation = 'lighter';
    for(var i=0;i<parts.length;i++){
      var p = parts[i];
      var tx = target.active ? target.x : (W/2 + Math.sin(tt*0.3 + p.ph)*W*0.3);
      var ty = target.active ? target.y : (H/2 + Math.cos(tt*0.4 + p.ph)*H*0.3);
      var dx = tx-p.x, dy = ty-p.y, d = Math.sqrt(dx*dx+dy*dy) || 1;
      var pull = target.active ? 0.012 : 0.004;
      p.vx += dx*pull; p.vy += dy*pull;
      p.vx *= 0.9; p.vy *= 0.9;
      p.x += p.vx; p.y += p.vy;
      ctx.fillStyle = 'rgba(79,139,255,' + (target.active ? 0.9 : 0.5) + ')';
      ctx.shadowColor = 'rgba(79,139,255,.9)'; ctx.shadowBlur = 10*DPR;
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.2832); ctx.fill();
      if(target.active && d < 150*DPR){
        ctx.shadowBlur = 0;
        ctx.strokeStyle = 'rgba(154,92,255,' + (0.24*(1 - d/(150*DPR))) + ')';
        ctx.lineWidth = 0.7*DPR;
        ctx.beginPath(); ctx.moveTo(p.x,p.y); ctx.lineTo(target.x,target.y); ctx.stroke();
      }
    }
    ctx.globalCompositeOperation = 'source-over'; ctx.shadowBlur = 0;
    raf = requestAnimationFrame(frame);
  }
  function start(){ if(running) return; running = true; raf = requestAnimationFrame(frame); }
  function stop(){ running = false; if(raf) cancelAnimationFrame(raf); }
  function staticFrame(){
    resize(); ctx.clearRect(0,0,W,H); ctx.globalCompositeOperation = 'lighter';
    for(var i=0;i<parts.length;i++){ var p = parts[i]; ctx.fillStyle = 'rgba(79,139,255,.5)'; ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,6.2832); ctx.fill(); }
    ctx.globalCompositeOperation = 'source-over';
  }
  resize();
  var rzC = null;
  window.addEventListener('resize', function(){ if(rzC) clearTimeout(rzC); rzC = setTimeout(resize, 150); });
  return { start:start, stop:stop, staticFrame:staticFrame, setTarget:function(x,y,a){ target.x=x; target.y=y; target.active=a; }, dpr:function(){ return DPR; }, rect:function(){ return canvas.getBoundingClientRect(); } };
}
var ctaObj = ctaSparks(document.getElementById('ctaField'));
gateCanvas(ctaObj, document.getElementById('start'));

/* ---------------- GSAP choreography ---------------- */
if(hasGSAP){
  gsap.defaults({ ease:'power3.out' });

  /* headline line-mask reveals */
  function revealHeading(el){
    if(hasSplit){
      try{
        var sp = new SplitText(el, { type:'lines', linesClass:'st-line' });
        sp.lines.forEach(function(ln){
          var w = document.createElement('span');
          w.style.display = 'block'; w.style.overflow = 'hidden';
          ln.parentNode.insertBefore(w, ln); w.appendChild(ln);
        });
        gsap.set(sp.lines, { yPercent:118 });
        gsap.to(sp.lines, { yPercent:0, duration:1, stagger:0.09, ease:'power4.out',
          scrollTrigger:{ trigger:el, start:'top 86%' } });
        return;
      }catch(e){}
    }
    gsap.from(el, { opacity:0, y:40, duration:0.9, scrollTrigger:{ trigger:el, start:'top 88%' } });
  }
  function initReveals(){
    if(!hasST || RM) return;
    document.querySelectorAll('.rvl').forEach(revealHeading);
    gsap.utils.toArray('.eyebrow').forEach(function(eb){
      gsap.from(eb, { opacity:0, x:-14, duration:0.7, scrollTrigger:{ trigger:eb, start:'top 92%' } });
    });
    ST.refresh();
  }
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(initReveals); } else { initReveals(); }

  /* hero intro (fires after the preloader) */
  window.__heroIntro = function(){
    if(RM){ return; }
    var tl = gsap.timeline();
    var lines = document.querySelectorAll('.hero-h1 .l > span');
    tl.fromTo(lines, { yPercent:120 }, { yPercent:0, duration:1.05, stagger:0.09, ease:'power4.out' }, 0)
      .from('.hero-tag', { y:18, opacity:0, duration:.65 }, 0.15)
      .from('.hero-sub', { y:22, opacity:0, duration:.7 }, 0.65)
      .from('.hero-actions > *', { y:20, opacity:0, duration:.65, stagger:.09 }, 0.8)
      .from('.hero-note', { opacity:0, duration:.6 }, 1)
      .from('.hero-stage', { y:46, opacity:0, duration:1, ease:'power3.out' }, 0.7)
      .from('.stage-hud .hud', { opacity:0, y:14, duration:.55, stagger:.07 }, 1.05)
      .from('.ticker-band', { opacity:0, duration:.6 }, 1.2);
    gsap.to('.hero-h1 em', { backgroundPositionX:'-220%', duration:9, ease:'none', repeat:-1 });
    var pulse = document.getElementById('tagPulse');
    if(pulse) gsap.to(pulse, { scale:1.55, opacity:.45, duration:.85, repeat:-1, yoyo:true, ease:'sine.inOut', transformOrigin:'50% 50%' });
  };

  if(hasST && !RM){
    /* hero parallax on exit */
    gsap.to('#heroLines', { yPercent:14, ease:'none', scrollTrigger:{ trigger:'#hero', start:'top top', end:'bottom top', scrub:0.5 } });
    gsap.to('.hero-copy', { yPercent:-9, ease:'none', scrollTrigger:{ trigger:'#hero', start:'top top', end:'bottom top', scrub:0.6 } });

    /* selling points */
    gsap.utils.toArray('[data-pt]').forEach(function(el, i){
      gsap.from(el, { y:40, opacity:0, duration:0.8, delay:i*0.06,
        scrollTrigger:{ trigger:'#points', start:'top 84%' } });
    });

    /* product cards */
    function cardsIn(cards){
      gsap.killTweensOf(cards);
      gsap.fromTo(cards, { y:44, opacity:0 }, { y:0, opacity:1, duration:0.75, stagger:0.06, ease:'power3.out', clearProps:'opacity' });
    }
    gsap.utils.toArray('#grid .product-card').forEach(function(card, i){
      gsap.from(card, { y:46, opacity:0, duration:0.8, delay:(i%3)*0.07,
        scrollTrigger:{ trigger:card, start:'top 90%' } });
    });
    window.__cardsIn = cardsIn;

    /* review cards + stars */
    gsap.utils.toArray('#proof .rev').forEach(function(rev, i){
      var tl = gsap.timeline({ scrollTrigger:{ trigger:rev, start:'top 88%' } });
      tl.from(rev, { y:38, opacity:0, duration:0.7 })
        .to(rev.querySelectorAll('.stars svg'), { opacity:1, duration:0.3, stagger:0.07, ease:'back.out(2)' }, '-=0.35');
    });

    /* stat counters */
    gsap.utils.toArray('#stats .k').forEach(function(el){
      var target = parseFloat(el.getAttribute('data-count')) || 0;
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      var suffix = el.getAttribute('data-suffix') || '';
      var obj = { v:0 };
      gsap.to(obj, { v:target, duration:1.6, ease:'power2.out',
        scrollTrigger:{ trigger:'#stats', start:'top 86%' },
        onUpdate:function(){ el.textContent = obj.v.toFixed(dec) + suffix; } });
    });
    gsap.from('#stats .stat', { opacity:0, y:24, duration:0.7, stagger:0.07, scrollTrigger:{ trigger:'#stats', start:'top 88%' } });
    gsap.from('#proof .press span', { opacity:0, y:16, duration:0.6, stagger:0.06, scrollTrigger:{ trigger:'#proof .press', start:'top 92%' } });

    /* how it works spine */
    (function(){
      var rail = document.getElementById('spineRail');
      if(rail){
        gsap.fromTo(rail, { scaleY:0 }, { scaleY:1, ease:'none',
          scrollTrigger:{ trigger:'#spine', start:'top 72%', end:'bottom 72%', scrub:0.5 } });
      }
      gsap.utils.toArray('#spine .stp').forEach(function(stp){
        var tl = gsap.timeline({ scrollTrigger:{ trigger:stp, start:'top 84%' } });
        tl.from(stp.querySelector('.stp-n'), { scale:0.4, opacity:0, duration:0.55, ease:'back.out(1.8)' })
          .from(stp.children[1], { x:28, opacity:0, duration:0.6 }, '-=0.28');
      });
    })();

    /* collection tiles */
    gsap.utils.toArray('#explore .tile').forEach(function(tile, i){
      gsap.from(tile, { y:48, opacity:0, duration:0.8, delay:(i%2)*0.08, scrollTrigger:{ trigger:tile, start:'top 90%' } });
      var art = tile.querySelector('[data-parallax]');
      if(art){
        gsap.fromTo(art, { yPercent:-7 }, { yPercent:7, ease:'none',
          scrollTrigger:{ trigger:tile, start:'top bottom', end:'bottom top', scrub:0.6 } });
      }
    });

    /* isi + faq entrances */
    gsap.utils.toArray('.isi-card, .isi-nitrate, .isi-warn-card, .isi-indication').forEach(function(el){
      gsap.from(el, { y:30, opacity:0, duration:0.75, scrollTrigger:{ trigger:el, start:'top 90%' } });
    });
    gsap.from('#faqList .faq-item', { y:24, opacity:0, duration:0.6, stagger:0.06, scrollTrigger:{ trigger:'#faqList', start:'top 86%' } });

    /* story: scrubbed current + beat lighting */
    (function(){
      var base = document.getElementById('storyBase'),
          live = document.getElementById('storyLive'),
          spark = document.getElementById('storySpark');
      if(!base || !live || !base.getTotalLength) return;
      var beats = Array.prototype.slice.call(document.querySelectorAll('#storySvg .beat'));
      var cards = Array.prototype.slice.call(document.querySelectorAll('[data-beat-card]'));
      var fr = [0.13, 0.44, 0.77];
      var len = base.getTotalLength();
      live.style.strokeDasharray = len; live.style.strokeDashoffset = len;
      function apply(p){
        p = Math.max(0, Math.min(1, p));
        live.style.strokeDashoffset = len*(1-p);
        var pt = base.getPointAtLength(len*p);
        if(spark){ spark.setAttribute('cx', pt.x); spark.setAttribute('cy', pt.y); }
        for(var i=0;i<fr.length;i++){
          var on = p >= fr[i] - 0.005;
          if(beats[i]) beats[i].classList.toggle('lit', on);
          if(cards[i]) cards[i].classList.toggle('lit', on);
        }
      }
      apply(0);
      ST.create({
        trigger:'#story', start:'top 68%', end:'bottom 78%', scrub:0.6,
        onUpdate:function(self){ apply(self.progress); },
        onRefresh:function(self){ apply(self.progress || 0); }
      });
    })();

    /* marquees bound to scroll velocity */
    (function(){
      var tracks = [
        { el:document.getElementById('heroTicker'), dur:34 },
        { el:document.getElementById('sloganTrack'), dur:28 },
        { el:document.getElementById('footTrack'), dur:24 }
      ];
      var tweens = [];
      tracks.forEach(function(t){
        if(!t.el) return;
        t.el.style.animation = 'none';
        tweens.push(gsap.to(t.el, { xPercent:-50, duration:t.dur, ease:'none', repeat:-1 }));
      });
      if(!tweens.length) return;
      ST.create({
        trigger:document.body, start:'top top', end:'bottom bottom',
        onUpdate:function(self){
          var v = Math.min(3.4, 1 + Math.abs(self.getVelocity())/1400);
          tweens.forEach(function(tw){ tw.timeScale(v); });
        }
      });
      var settle = null;
      window.addEventListener('scroll', function(){
        if(settle) clearTimeout(settle);
        settle = setTimeout(function(){ tweens.forEach(function(tw){ gsap.to(tw, { timeScale:1, duration:0.7, ease:'power2.out' }); }); }, 180);
      }, {passive:true});
    })();
  }
}

/* reduced-motion / no-ScrollTrigger static completion for the story piece */
if(RM || !hasST){
  try{
    var _base = document.getElementById('storyBase'), _live = document.getElementById('storyLive'), _sp = document.getElementById('storySpark');
    if(_live){ _live.style.strokeDasharray = 'none'; _live.style.strokeDashoffset = '0'; }
    if(_base && _base.getTotalLength && _sp){
      var _pt = _base.getPointAtLength(_base.getTotalLength());
      _sp.setAttribute('cx', _pt.x); _sp.setAttribute('cy', _pt.y);
    }
    document.querySelectorAll('#storySvg .beat').forEach(function(b){ b.classList.add('lit'); });
    document.querySelectorAll('[data-beat-card]').forEach(function(c){ c.classList.add('lit'); });
    document.querySelectorAll('.stars svg').forEach(function(s){ s.style.opacity = '1'; });
  }catch(e){}
}
if(RM){ document.querySelectorAll('.stars svg').forEach(function(s){ s.style.opacity = '1'; }); }

/* ---------------- treatment filter chips ---------------- */
(function(){
  var row = document.getElementById('chipRow'), grid = document.getElementById('grid');
  if(!row || !grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
  row.addEventListener('click', function(e){
    var chip = e.target.closest ? e.target.closest('.chip') : null;
    if(!chip) return;
    var f = chip.getAttribute('data-filter');
    row.querySelectorAll('.chip').forEach(function(c){ c.classList.toggle('on', c === chip); });
    var shown = [];
    cards.forEach(function(card){
      var match = (f === 'all') || card.getAttribute('data-cat') === f;
      card.style.display = match ? '' : 'none';
      if(match) shown.push(card);
    });
    if(hasGSAP && !RM && window.__cardsIn) window.__cardsIn(shown);
    if(hasST) ST.refresh();
  });
})();

/* ---------------- card consult routing (compliant stand-in) ---------------- */
(function(){
  var navCta = document.getElementById('navCta');
  document.querySelectorAll('[data-consult]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var card = btn.closest ? btn.closest('.product-card') : null;
      var pulse = card ? card.querySelector('.pc-pulse') : null;
      if(pulse && hasGSAP && !RM){
        gsap.fromTo(pulse, { opacity:0.95, scale:0.985 }, { opacity:0, scale:1.02, duration:0.75, ease:'power2.out', transformOrigin:'50% 50%' });
      }
      if(navCta){
        navCta.classList.remove('charged');
        void navCta.offsetWidth;
        navCta.classList.add('charged');
      }
      if(chamber && !RM) chamber.surge(0.7);
    });
  });
})();

/* ---------------- FAQ accordion ---------------- */
(function(){
  var items = document.querySelectorAll('.faq-item');
  items.forEach(function(it){
    var q = it.querySelector('.faq-q'), a = it.querySelector('.faq-a'), inner = it.querySelector('.faq-a-inner');
    if(!q || !a || !inner) return;
    q.setAttribute('aria-expanded', 'false');
    q.addEventListener('click', function(){
      var open = it.classList.contains('open');
      items.forEach(function(o){
        if(o !== it){
          o.classList.remove('open');
          var oq = o.querySelector('.faq-q'); if(oq) oq.setAttribute('aria-expanded','false');
          var oa = o.querySelector('.faq-a');
          if(oa){ if(hasGSAP) gsap.to(oa, { height:0, duration:.4, ease:'power3.inOut' }); else oa.style.height = '0px'; }
        }
      });
      if(open){
        it.classList.remove('open'); q.setAttribute('aria-expanded','false');
        if(hasGSAP) gsap.to(a, { height:0, duration:.4, ease:'power3.inOut' }); else a.style.height = '0px';
      } else {
        it.classList.add('open'); q.setAttribute('aria-expanded','true');
        var h = inner.offsetHeight;
        if(hasGSAP) gsap.fromTo(a, { height:0 }, { height:h, duration:.5, ease:'power3.out' }); else a.style.height = h + 'px';
      }
    });
  });
})();

/* ---------------- magnetic buttons + CTA spark gather ---------------- */
(function(){
  if(RM || !isDesktop) return;
  document.querySelectorAll('[data-magnetic]').forEach(function(btn){
    var strength = 0.28;
    btn.addEventListener('mousemove', function(e){
      var r = btn.getBoundingClientRect();
      var mx = e.clientX - r.left - r.width/2, my = e.clientY - r.top - r.height/2;
      if(hasGSAP) gsap.to(btn, { x:mx*strength, y:my*strength, duration:.5, ease:'power3.out' });
      else btn.style.transform = 'translate(' + (mx*strength) + 'px,' + (my*strength) + 'px)';
    });
    btn.addEventListener('mouseleave', function(){
      if(hasGSAP) gsap.to(btn, { x:0, y:0, duration:.6, ease:'elastic.out(1,0.4)' });
      else btn.style.transform = '';
    });
  });
  var mb = document.getElementById('magnetBtn');
  if(mb && ctaObj){
    var upd = function(active){
      var cr = ctaObj.rect(), br = mb.getBoundingClientRect(), d = ctaObj.dpr();
      ctaObj.setTarget((br.left - cr.left + br.width/2)*d, (br.top - cr.top + br.height/2)*d, active);
    };
    mb.addEventListener('mouseenter', function(){ upd(true); });
    mb.addEventListener('mousemove', function(){ upd(true); });
    mb.addEventListener('mouseleave', function(){ ctaObj.setTarget(0,0,false); });
  }
})();

/* ---------------- easter egg: type SPARK ---------------- */
(function(){
  if(RM) return;
  var buf = '';
  window.addEventListener('keydown', function(e){
    if(!e.key || e.key.length !== 1) return;
    var tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : '';
    if(tag === 'input' || tag === 'textarea') return;
    buf = (buf + e.key.toLowerCase()).slice(-5);
    if(buf === 'spark'){
      buf = '';
      if(chamber) chamber.blast();
      var bloom = document.createElement('div');
      bloom.style.cssText = 'position:fixed;inset:0;z-index:9700;pointer-events:none;background:radial-gradient(60% 50% at 50% 50%,rgba(79,139,255,.42),rgba(107,33,216,.16) 55%,transparent 78%);opacity:0';
      document.body.appendChild(bloom);
      if(hasGSAP){
        gsap.timeline()
          .to(bloom, { opacity:1, duration:0.16, ease:'power2.out' })
          .to(bloom, { opacity:0, duration:0.9, ease:'power2.in', onComplete:function(){ bloom.remove(); } });
      } else {
        setTimeout(function(){ bloom.remove(); }, 700);
      }
      scrollToId('#hero');
    }
  });
})();

/* ---------------- logo click: spark burst ---------------- */
(function(){
  var logo = document.getElementById('brandLogo'); if(!logo || RM) return;
  logo.addEventListener('click', function(e){
    for(var i=0;i<16;i++){
      var s = document.createElement('div');
      s.style.cssText = 'position:fixed;left:' + e.clientX + 'px;top:' + e.clientY + 'px;width:6px;height:6px;border-radius:50%;pointer-events:none;z-index:9700;background:' + (i%2 ? '#4F8BFF' : '#9A5CFF') + ';box-shadow:0 0 10px #4F8BFF';
      document.body.appendChild(s);
      var ang = Math.random()*6.2832, dist = 60 + Math.random()*110;
      if(hasGSAP){
        gsap.to(s, { x:Math.cos(ang)*dist, y:Math.sin(ang)*dist, opacity:0, scale:0.2, duration:0.7 + Math.random()*0.45, ease:'power3.out',
          onComplete:function(){ this.targets()[0].remove(); } });
      } else {
        setTimeout((function(el){ return function(){ el.remove(); }; })(s), 700);
      }
    }
  });
})();

/* ---------------- newsletter mock ---------------- */
(function(){
  var btn = document.getElementById('newsBtn'), input = document.getElementById('newsMail');
  if(!btn) return;
  btn.addEventListener('click', function(){
    var old = btn.textContent;
    btn.textContent = 'Demo only';
    if(input) input.value = '';
    setTimeout(function(){ btn.textContent = old; }, 1800);
  });
})();

/* ---------------- burger ---------------- */
(function(){ var b = document.getElementById('burger'); if(b) b.addEventListener('click', function(){ scrollToId('#start'); }); })();

/* ---------------- preloader ---------------- */
(function(){
  var pl = document.getElementById('preloader'),
      count = document.getElementById('plCount'),
      arc = document.getElementById('plArc'),
      spark = document.getElementById('plSpark');
  function finish(){
    if(pl){
      if(hasGSAP) gsap.to(pl, { opacity:0, duration:0.55, ease:'power2.inOut', onComplete:function(){ pl.style.display = 'none'; } });
      else pl.style.display = 'none';
    }
    if(hasGSAP && window.__heroIntro) window.__heroIntro();
    if(hasST) setTimeout(function(){ ST.refresh(); }, 240);
  }
  if(RM){ if(pl) pl.style.display = 'none'; if(hasST) ST.refresh(); return; }
  var start = performance.now(), dur = 1350;
  var alen = (arc && arc.getTotalLength) ? arc.getTotalLength() : 0;
  if(arc && alen){ arc.style.strokeDasharray = alen; arc.style.strokeDashoffset = alen; }
  function tick(now){
    var p = Math.min(1, (now-start)/dur), e = 1 - Math.pow(1-p, 3);
    if(count) count.textContent = String(Math.round(e*100));
    if(arc && alen) arc.style.strokeDashoffset = alen*(1-e);
    if(spark && arc && arc.getPointAtLength && alen){
      var pt = arc.getPointAtLength(alen*e);
      spark.setAttribute('cx', pt.x); spark.setAttribute('cy', pt.y);
    }
    if(p < 1) requestAnimationFrame(tick); else setTimeout(finish, 150);
  }
  requestAnimationFrame(tick);
  setTimeout(function(){ if(pl && pl.style.display !== 'none') finish(); }, 2500);
})();

/* ---------------- refresh after load ---------------- */
window.addEventListener('load', function(){ if(hasST) setTimeout(function(){ ST.refresh(); }, 300); });

})();


/* Shopify editor refresh */
(function(){['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(function(evt){document.addEventListener(evt,function(){if(window.ScrollTrigger){setTimeout(function(){ScrollTrigger.refresh(true);},80);}});});})();
